import React, { useState } from 'react';
import '../Styles/JoinOurTeam.scss';
import joinUs from '../Assests/JoinUs/joinUs.svg'
import { toast } from 'react-toastify';
function JoinOurTeam({ closeModal }) {

    const [uploading, setUploading] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        position: '',
        experience: '',
        message: '',
        selectedFiles: null
    });

    const [formErrors, setFormErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        position: '',
        experience: '',
        message: '',
        selectedFiles: ''
    });

    const restrictEmojis = (value) => {
        const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{23F0}\u{231A}]/gu;
        return value.replace(emojiRegex, '');
    };




    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData((prevData) => ({
            ...prevData,
            selectedFiles: file,
        }));


        if (formErrors.selectedFiles) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedFiles: '',
            }));
        }
    };


    const blockNumSpec = (value) => {
        value = value.replace(/[0-9]/g, '');

        value = value.replace(/[^a-zA-Z\s\-]/g, '');

        return value;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let updatedValue = value;

        if (name === 'firstName' || name === 'lastName' || name === "position" ) {
            updatedValue = blockNumSpec(value); 
        }

        const cleanedValue = restrictEmojis(updatedValue);

        setFormData(prevData => ({
            ...prevData,
            [name]: cleanedValue
        }));

        if (formErrors[name]) {
            setFormErrors(prevErrors => ({
                ...prevErrors,
                [name]: ''
            }));
        }
    };



    const validateForm = () => {
        let errors = {};
        let isValid = true;

        Object.keys(formData).forEach((field) => {
            if (formData !== 'message' && !formData[field]) {
                errors[field] = `${field} is required`;
                isValid = false;
            }
        });

        if (formData.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            errors.email = 'Please enter a valid email address';
            isValid = false;
        }

        if (!formData.selectedFiles) {
            errors.selectedFiles = 'Please upload a file';
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };



    const handleUpload = async () => {
        if (!validateForm()) {
            return;
        }

        setUploading(true);

        const apiUrl = `${process.env.REACT_APP_VIZZHY_WEBSITE_API_URL}/homePage/careerInfo?requestId=123`;
        const apiKey = process.env.REACT_APP_API_KEY_VIZZHYWEB


        const form = new FormData();
        form.append(
            'data',
            JSON.stringify({
                firstName: formData.firstName,
                lastName: formData.lastName,
                emailId: formData.email,
                position: formData.position,
                experience: `${formData.experience}`,
                phoneNumber: formData.phoneNumber,
            })
        );
        form.append('file', formData.selectedFiles);

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'x-api-key': apiKey,
                },
                body: form,
            });

            const result = await response.json();

            if (response.ok) {
                toast.success('Thank you for applying! 😊');
                closeModal();
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phoneNumber: '',
                    position: '',
                    experience: '',
                    message: '',
                    selectedFiles: null,
                });

            } else {

                if (result?.errors && result?.errors?.length > 0) {
                    result?.errors?.forEach((error) => {
                        toast.error(error);
                    });
                } else {
                    toast.error(result?.error?.message || 'Upload failed. Please try again.');
                }
            }
        } catch (err) {
            toast.error('An error occurred while uploading. Please try again.');
        } finally {
            setUploading(false);
        }
    };
    return (
        <>
            <div className='mx-2'>

                <div className='row'>

                    <div className="col-md-5 rounded position-relative bg-dark-purple">
                        <div className="ms-3 join-us-mob">
                            <div className="fs-4 fw-bold text-white">
                                Join Our Vizzhy Team!
                            </div>
                            <div className="mt-2 fs-6 text-light-gray lh-sm">
                                <div>Be part of a team dedicated to transforming</div>
                                <div>health and wellness through innovation.</div>
                            </div>
                        </div>

                        <img
                            src={joinUs}
                            alt="Join Us"
                            className="join-us-image"
                        />
                    </div>

                    <div className='col-md-7'>
                        <div className='text-end ' onClick={() => {
                            setFormData({
                                firstName: '',
                                lastName: '',
                                email: '',
                                phoneNumber: '',
                                position: '',
                                experience: '',
                                message: '',
                                selectedFiles: null,
                            });
                            closeModal();
                        }}
                        >
                            <span class="material-symbols-outlined cursor-pointer">
                                close
                            </span>
                        </div>
                        <div className='row '>
                            <div className='col-md-6  margin-mob-height'>
                                <label className='overall-text-color'>First Name <span className='red-star'>*</span></label>
                                <input
                                    type="text"
                                    className="no-border"
                                    placeholder="Enter First Name"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                />
                                {formErrors.firstName && <small className="text-danger">{formErrors.firstName}</small>}
                            </div>
                            <div className='col-md-6  margin-mob-height'>
                                <label className='overall-text-color'>Last Name <span className='red-star'>*</span></label>
                                <input
                                    type="text"
                                    className="no-border"
                                    placeholder="Enter Last Name"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                />
                                {formErrors.lastName && <small className="text-danger">{formErrors.lastName}</small>}
                            </div>
                        </div>
                        <div className='row margin-web-height'>
                            <div className='col-md-6  margin-mob-height'>
                                <label className='overall-text-color'>Email <span className='red-star'>*</span></label>
                                <input
                                    type="email"
                                    className="no-border"
                                    placeholder="Enter your email address"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                            </div>
                            <div className='col-md-6  margin-mob-height'>
                                <label className='overall-text-color'>Phone Number <span className='red-star'>*</span></label>
                                <input
                                    type="text"
                                    className="no-border"
                                    placeholder="Enter your phone number"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleInputChange}
                                    maxLength="15"
                                    onInput={(e) => {
                                        let input = e.target.value;

                                        if (input.startsWith('+')) {
                                            input = '+' + input.slice(1).replace(/[^0-9]/g, '').slice(0, 15);
                                        } else {
                                            input = input.replace(/[^0-9]/g, '').slice(0, 15);
                                        }

                                        e.target.value = input;
                                        handleInputChange(e);
                                    }}
                                />

                                {formErrors.phoneNumber && <small className="text-danger">{formErrors.phoneNumber}</small>}
                            </div>

                        </div>
                        <div className='row   margin-web-height' >
                            <div className='col-md-6 margin-mob-height '>
                                <label className='overall-text-color'>Position Applying For <span className='red-star'>*</span></label>
                                <input
                                    type="text"
                                    className="no-border"
                                    placeholder="Eg: Software Engineering"
                                    name="position"
                                    value={formData.position}
                                    onChange={handleInputChange}
                                />
                                {formErrors.position && <small className="text-danger">{formErrors.position}</small>}
                            </div>
                            <div className='col-md-6  margin-mob-height'>
                                <label className='overall-text-color'>Experience <span className='red-star'>*</span></label>
                                <input
                                    type="text"
                                    className="no-border"
                                    placeholder="Eg: 2 Years"
                                    name="experience"
                                    value={formData.experience}
                                    onChange={handleInputChange}
                                />
                                {formErrors.experience && <small className="text-danger">{formErrors.experience}</small>}
                            </div>
                            <div className=' margin-mob-height  margin-web-height'>
                                {/* <label className='overall-text-color'>Message <span className='red-star'>*</span></label> */}
                                <label className='overall-text-color'>Message</label>

                                <input
                                    type="text"
                                    className="no-border"
                                    placeholder="Enter Message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                />
                                {/* {formErrors.message && <small className="text-danger">{formErrors.message}</small>} */}
                            </div>
                        </div>
                        <div>
                            <div className="row m-2 mt-4 pt-4">
                                <label className="drop-container col-sm-12 px-4 py-3">
                                    <div className='d-flex'>
                                        <span className="material-symbols-outlined">
                                            cloud_upload
                                        </span>
                                        <span className="drop-title text-center overall-text-color"><b>Upload File*</b></span>
                                    </div>
                                    <div className="ps-5">
                                        <input
                                            type="file"
                                            className="file-name-text"
                                            onChange={handleFileChange}
                                            accept=".pdf"
                                            style={{ display: 'none' }}
                                            id="fileInput"
                                        />
                                    </div>
                                </label>
                                <div className='pt-2'>
                                    {formData.selectedFiles && (
                                        <div className="mt-2 p-1 bg-light rounded ms-3 d-flex align-items-center justify-content-between">
                                            <b>Selected File: </b>
                                            <span>{formData.selectedFiles.name}</span>

                                            <span
                                                className="material-symbols-outlined cursor-pointer"
                                                onClick={() => setFormData(prevState => ({ ...prevState, selectedFiles: null }))}
                                            >
                                                close
                                            </span>
                                        </div>
                                    )}
                                    {formErrors.selectedFiles && <div className="text-danger ">{formErrors.selectedFiles}</div>}
                                </div>
                            </div>


                        </div>


                        <div className="mt-4 d-flex justify-content-end ">
                            <div
                                className='primary-btn text-center ms-1 py-2 px-4 contact-us fw-bold'
                                onClick={handleUpload}
                                disabled={uploading}
                            >
                                {uploading ? 'Applying...' : 'Apply'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default JoinOurTeam;
